(function () {
  const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  const REVISION = '2026-07-15';
  const TIMEOUT_MS = 10000;

  function initNewsletter(root) {
    (root || document).querySelectorAll('[data-klaviyo-newsletter]').forEach(function (wrapper) {
      if (wrapper.dataset.klaviyoBound === '1') return;

      const companyId = (wrapper.dataset.klaviyoCompany || '').trim();
      const listId = (wrapper.dataset.klaviyoList || '').trim();
      if (!companyId || !listId) {
        console.warn('[klaviyo] missing company or list id', { companyId: companyId, listId: listId });
        return;
      }

      const input = wrapper.querySelector('input[type="email"]');
      const button = wrapper.querySelector('button');
      const status = wrapper.querySelector('[data-newsletter-status]');
      if (!input || !button) {
        console.warn('[klaviyo] input or button not found in', wrapper);
        return;
      }

      const messages = {
        invalid: wrapper.dataset.msgInvalid || 'Please enter a valid email address.',
        success: wrapper.dataset.msgSuccess || 'Thanks for subscribing!',
        error: wrapper.dataset.msgError || 'Something went wrong. Please try again.'
      };

      wrapper.dataset.klaviyoBound = '1';
      let inFlight = false;

      function setStatus(message, isError) {
        if (!status) return;
        status.textContent = message;
        status.classList.toggle('newsletter__status--error', !!isError);
      }

      function dismissPopup() {
        if (!('klaviyoDismiss' in wrapper.dataset)) return;
        try { localStorage.setItem('theme:popup-filled', 'true'); } catch (e) {}
        const popup = wrapper.closest('newsletter-popup');
        if (!popup) return;
        const closeBtn = popup.querySelector('[close-drawer]');
        if (closeBtn) setTimeout(function () { closeBtn.click(); }, 1500);
      }

      async function handleSubmit() {
        if (inFlight) return;

        const email = (input.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          setStatus(messages.invalid, true);
          input.focus();
          return;
        }

        inFlight = true;
        button.disabled = true;
        setStatus('');

        const controller = new AbortController();
        const timeoutId = setTimeout(function () { controller.abort(); }, TIMEOUT_MS);

        try {
          const res = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
            {
              method: 'POST',
              headers: {
                accept: 'application/json',
                'content-type': 'application/json',
                revision: REVISION
              },
              signal: controller.signal,
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: wrapper.dataset.klaviyoSource || 'Newsletter',
                    profile: { data: { type: 'profile', attributes: { email: email } } }
                  },
                  relationships: {
                    list: { data: { type: 'list', id: listId } }
                  }
                }
              })
            }
          );

          if (res.status === 202) {
            setStatus(messages.success);
            input.value = '';
            dismissPopup();
          } else {
            const body = await res.text().catch(function () { return ''; });
            console.error('[klaviyo] error', res.status, body);
            setStatus(messages.error, true);
          }
        } catch (err) {
          if (err && err.name === 'AbortError') {
            console.error('[klaviyo] request timed out after', TIMEOUT_MS, 'ms');
          } else {
            console.error('[klaviyo] network error', err);
          }
          setStatus(messages.error, true);
        } finally {
          clearTimeout(timeoutId);
          inFlight = false;
          button.disabled = false;
        }
      }

      button.addEventListener('click', handleSubmit);

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          handleSubmit();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initNewsletter(); });
  } else {
    initNewsletter();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initNewsletter(event.target);
  });
})();